export const DOG_DESKTOP_QUERY =
    "(min-width: 1024px) and (orientation: landscape), (min-width: 1280px)";

export const DOG_HEADER_VARS =
    "dog-desktop:[--container-page:100rem] dog-desktop:[--dog-navigation-height:var(--spacing-header)] dog-desktop:[--dog-context-height:60px] dog-desktop:[--dog-header-height:calc(var(--dog-navigation-height)+var(--dog-context-height))]";

export const DOG_DESKTOP_GRID = `${DOG_HEADER_VARS} dog-desktop:page-container dog-desktop:page-grid dog-desktop:items-start`;

export const DOG_CONTENT_COLUMN =
    "dog-desktop:col-start-8 dog-desktop:col-span-5";
